import { render, staticRenderFns } from "./formButtons.vue?vue&type=template&id=3f991632&"
import script from "./formButtons.vue?vue&type=script&lang=js&"
export * from "./formButtons.vue?vue&type=script&lang=js&"
import style0 from "./formButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports